module.exports = __webpack_public_path__ + "img/template_placeholder_red.4e842a7.png";